import React, { useState, useEffect } from "react";
import LeftSidebar from "components/left_sidebar";
import AddMetaTags from "components/add_meta_tags";
import { toastError, toastSuccess } from "helpers/toastHelper";
import { contributeTechnical } from "apis/technical_process";
import { fetchCatalogueTechnicalProcess } from "redux/actions/technical_process";
import { useDispatch, useSelector } from "react-redux";
import Quill from "./editor";
import { useAgrid } from "agrid-js/react";
function ContributeTechnicalProcess(props) {
  const dispatch = useDispatch();
  const agrid = useAgrid();
  const [title, setTitle] = useState("");
  const [contentSections, setContentSections] = useState([{ title: "", content: "" }]);
  const [categoryId, setCategoryId] = useState(null);
  const [parentCatalogId, setParentCatalogId] = useState(null);
  const [processTypeId, setProcessTypeId] = useState(null);
  const [fileImages, setFileImages] = useState([]);
  const [urlImages, setUrlImages] = useState([]);
  const [isSending, setIsSending] = useState(false);
  const [fileInputKey, setFileInputKey] = useState(Date.now()); // Add a key for the file input
  const [editorKey, setEditorKey] = useState(Date.now()); // Add a key for the Quill editor to force re-render
  const [justSubmitted, setJustSubmitted] = useState(false); // Track if form was just submitted
  const [formKey, setFormKey] = useState(Date.now()); // Add a key for the entire form to force re-render
  const listParentCatalog = useSelector((state) => state.technicalProcess.listCatalogueTechnicalProcess.data);
  const listplants = useSelector((state) => state.technicalProcess.listCatalogueTechnicalProcess.data);
  const listCropProcesses = useSelector((state) => state.technicalProcess.listCatalogueTechnicalProcess.data);

  // Filter plants based on selected parent catalog
  const filteredParentCatalogs = listParentCatalog
    ? listParentCatalog?.filter(catalogue => !catalogue.parent_id)
    : [];

  // Filter plants based on selected parent catalog
  const filteredPlants = parentCatalogId
    ? listplants?.filter(plant => plant.parent_id === parentCatalogId)
    : [];

  // Filter crop processes based on selected plant
  const filteredCropProcesses = categoryId
    ? listCropProcesses?.filter(process => process.parent_id === categoryId)
    : [];
  // Prepare the content sections in the format expected by the API
  const prepareContentSectionsForSubmit = () => {
    const result = {};
    contentSections.forEach((section, index) => {
      result[index.toString()] = {
        title: section.title,
        content: section.content,
        _destroy: "false"
      };
    });
    return result;
  };

  const fieldParams = {
    title: title,
    content: "", // We'll use technical_process_contents_attributes instead
    technical_process_catalogue_id: parentCatalogId,
    plant_id: categoryId,
    crop_process: processTypeId,
    "attachment[file][]": fileImages,
    technical_process_contents_attributes: prepareContentSectionsForSubmit()
  };
  useEffect(() => {
    dispatch(fetchCatalogueTechnicalProcess({page: 1, limit: 1000}));
  }, []);

  // Handle content section changes
  const handleContentSectionChange = (index, field, value) => {
    // Create a deep copy of the content sections array
    const updatedSections = [...contentSections];

    // Create a new object for the section being updated
    updatedSections[index] = {
      ...updatedSections[index],
      [field]: value
    };

    // Update the state with the new array
    setContentSections(updatedSections);
  };

  // Add a new content section
  const addContentSection = () => {
    // Create a deep copy of the current sections and add a new empty one
    const newSections = [...contentSections.map(section => ({...section})), { title: "", content: "" }];
    setContentSections(newSections);
  };

  // Remove a content section
  const removeContentSection = (index) => {
    if (contentSections.length > 1) {
      // Create a deep copy of the current sections
      const updatedSections = contentSections.map(section => ({...section}));
      // Remove the section at the specified index
      updatedSections.splice(index, 1);
      setContentSections(updatedSections);
    } else {
      toastError("Phải có ít nhất một phần nội dung");
    }
  };

  const uploadImages = (e) => {
    const files = Array.from(e.target.files);

    // Check if all files are images
    const nonImageFiles = files.filter(file => !file.type.includes("image"));
    if (nonImageFiles.length > 0) {
      return toastError("Vui lòng chỉ chọn ảnh");
    }

    if (files.length < 3) {
      return toastError("Vui lòng chọn tối thiểu là 3 ảnh");
    }

    // Create URLs for preview
    const newUrls = files.map(file => URL.createObjectURL(file));

    // Update state with new files and URLs
    setFileImages([...fileImages, ...files]);
    setUrlImages([...urlImages, ...newUrls]);
  };

  const resetState = () => {
    // Generate a new key for all components
    const newKey = Date.now();

    // Reset the form key to force a complete re-render of the entire form
    setFormKey(newKey);

    // Update the editor key to force re-rendering of editors
    setEditorKey(newKey);

    // Reset all form fields
    setTitle("");

    // Create a completely new array with one empty section
    setContentSections([{ title: "", content: "" }]);

    // Reset all other form fields
    setCategoryId(null);
    setParentCatalogId(null);
    setProcessTypeId(null);
    setFileImages([]);
    setUrlImages([]);
    setIsSending(false);

    // Reset the file input key
    setFileInputKey(newKey);

    // Set flag to prevent immediate resubmission
    setJustSubmitted(true);

    // Reset the justSubmitted flag after a delay
    setTimeout(() => {
      setJustSubmitted(false);
    }, 2000);
  };

  const sendData = (fieldParams) => {
    // If the form was just submitted and reset, prevent immediate resubmission
    if (justSubmitted) {
      return toastError("Đóng góp đã được gửi thành công. Vui lòng điền thông tin mới để đóng góp lại.");
    }

    // Check if the form is empty (just after reset)
    const isFormEmpty = !title.trim() &&
                        contentSections.length === 1 &&
                        !contentSections[0].title.trim() &&
                        (!contentSections[0].content || contentSections[0].content.trim() === '') &&
                        !categoryId &&
                        !processTypeId &&
                        fileImages.length === 0;

    // If the form is empty, don't submit
    if (isFormEmpty) {
      return toastError("Vui lòng điền thông tin trước khi đóng góp");
    }

    // Check if any content section is empty
    const hasEmptySection = contentSections.some(section => {
      // Check if title is empty
      if (!section.title.trim()) return true;

      // If content is completely empty
      if (!section.content || section.content.trim() === '') return true;

      // If content has an image, consider it valid
      if (section.content.includes('<img')) return false;

      // Check if content only has empty paragraphs
      const onlyEmptyParagraphs = /^(\s*<p>(\s|<br\s*\/?>)*<\/p>\s*)*$/i.test(section.content);
      return onlyEmptyParagraphs;
    });

    if (!title.trim()) {
      return toastError("Vui lòng nhập tiêu đề");
    }

    if (hasEmptySection) {
      return toastError("Vui lòng nhập đầy đủ tiêu đề và nội dung cho mỗi phần");
    }

    if (!categoryId || !processTypeId) {
      return toastError("Vui lòng chọn đầy đủ thông tin cây trồng và quy trình");
    }

    if (fileImages.length < 3) {
      return toastError("Vui lòng chọn ít nhất 3 hình ảnh");
    }
    const formData = new FormData();

    // Add basic fields
    formData.append('title', fieldParams.title);
    formData.append('content', fieldParams.content);
    formData.append('technical_process_catalogue_id', fieldParams.technical_process_catalogue_id);
    formData.append('plant_id', fieldParams.plant_id);
    formData.append('crop_process', fieldParams.crop_process);

    // Add nested content sections
    const contentAttrs = fieldParams.technical_process_contents_attributes;
    for (const index in contentAttrs) {
      formData.append(`technical_process_contents_attributes[${index}][title]`, contentAttrs[index].title);
      formData.append(`technical_process_contents_attributes[${index}][content]`, contentAttrs[index].content);
      formData.append(`technical_process_contents_attributes[${index}][_destroy]`, contentAttrs[index]._destroy);
    }

    // Add each file individually with the same field name
    fileImages.forEach(file => {
      formData.append("attachment[file][]", file);
    });
    setIsSending(true);
    contributeTechnical({ formData: formData })
      .then((res) => {
        if (res) {
          toastSuccess("Đóng góp thành công");
          agrid?.capture("Contribution - Technical Process", {
            object_type: "technical_processes",
            parent_catalog_id: parentCatalogId,
            plant_id: categoryId,
            crop_process: processTypeId,
            images_count: fileImages.length,
            sections_count: contentSections.length,
            title: title,
          });

          // Reset the form state completely with a delay to ensure proper UI update
          setTimeout(() => {
            // Create a completely new content sections array
            setContentSections([{ title: "", content: "" }]);

            // Then reset all other state
            resetState();
          }, 200);
        }
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        toastError("Có lỗi xảy ra, vui lòng thử lại");
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return (
    <>
      <AddMetaTags title={"Đóng góp quy trình kĩ thuật"} />
      <div className="row">
        <LeftSidebar />
        <div className="col-md-9 col-sm-12">
          <div className="container traceability-home">
            <div className="row">
              <h5> Đóng góp quy trình kĩ thuật</h5>
            </div>
            <div className="col-9 mx-auto mt-3">
              <div className="traceability-form" data-ph-no-capture key={`form-container-${formKey}`}>
                <div className="row">
                  <label htmlFor="title">
                    Nhập tiêu đề<span className="red-clr">*</span>
                  </label>
                  <input
                    className="traceability-input"
                    name="title"
                    type="text"
                    placeholder="Nhập tiêu đề"
                    required
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>

                <div className="row mb-3" key={`content-sections-container-${editorKey}`}>
                  <label>
                    Nội dung chi tiết<span className="red-clr">*</span>
                  </label>

                  {contentSections.map((section, index) => (
                    <div key={`section-${editorKey}-${index}`} className="content-section mb-3 p-3 border rounded">

                      <div className="mb-3">
                        <label htmlFor={`section-title-${index}`} className="form-label">
                          Tiêu đề<span className="red-clr">*</span>
                        </label>
                        <input
                          key={`title-${editorKey}-${index}`}
                          id={`section-title-${index}`}
                          className="form-control"
                          type="text"
                          placeholder="Nhập tiêu đề phần"
                          value={section.title || ""}
                          onChange={(e) => handleContentSectionChange(index, 'title', e.target.value)}
                        />
                      </div>

                      <div className="quill-editor-container">
                        <label htmlFor={`section-content-${index}`} className="form-label">
                          Nội dung<span className="red-clr">*</span>
                        </label>
                        <Quill
                          key={`quill-${editorKey}-${index}`}
                          id={`section-content-${index}`}
                          value={section.content || ""}
                          onChange={(content) => handleContentSectionChange(index, 'content', content)}
                          placeholder="Nhập nội dung phần"
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center mb-2 float-right">
                        {contentSections.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => removeContentSection(index)}
                          >
                            Xóa phần này
                          </button>
                        )}
                      </div>
                    </div>
                  ))}

                  <div className="text-center mt-2">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={addContentSection}
                    >
                      + Thêm phần nội dung
                    </button>
                  </div>
                </div>

                <div className="row">
                  <label>
                    Nhóm cây trồng
                    <span className="red-clr">*</span>
                  </label>

                  <select
                    value={parentCatalogId || "default"}
                    onChange={(e) => {
                      const value = e.target.value !== "default" ? e.target.value : null;
                      setParentCatalogId(value);
                      // Reset category ID when parent changes
                      setCategoryId(null);
                    }}
                  >
                    <option className="placeholder" value="default" hidden>
                      Chọn nhóm cây trồng
                    </option>
                    {filteredParentCatalogs?.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="row">
                  <label>
                    Loại cây trồng
                    <span className="red-clr">*</span>
                  </label>

                  <select
                    value={categoryId || "default"}
                    onChange={(e) => setCategoryId(e.target.value !== "default" ? e.target.value : null)}
                    disabled={!parentCatalogId}
                  >
                    <option className="placeholder" value="default" hidden>
                      {!parentCatalogId ? "Vui lòng chọn nhóm cây trồng trước" : "Chọn loại cây trồng"}
                    </option>
                    {filteredPlants?.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="row">
                  <label>
                    Loại quy trình
                    <span className="red-clr">*</span>
                  </label>

                  <select
                    value={processTypeId || "default"}
                    onChange={(e) => setProcessTypeId(e.target.value !== "default" ? e.target.value : null)}
                    disabled={!categoryId}
                  >
                    <option className="placeholder" value="default" hidden>
                      {!categoryId ? "Vui lòng chọn loại cây trồng trước" : "Chọn loại quy trình"}
                    </option>
                    {filteredCropProcesses?.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="row">
                  <div className="d-flex justify-content-between">
                    <label htmlFor="myFile" className="mb-2">
                      Hình ảnh đóng góp<span className="red-clr">*</span>
                    </label>

                    <span className="icon-camera" />
                  </div>

                  {/* Image previews */}
                  {urlImages.length > 0 && (
                    <div className="image-previews d-flex flex-wrap mb-3">
                      {urlImages.map((url, index) => (
                        <div key={index} className="position-relative me-2 mb-2">
                          <img
                            src={url}
                            alt={`dong-gop-quy-trinh-ki-thuat-hinh-anh-${index}`}
                            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                          />
                          <button
                            type="button"
                            className="btn btn-sm btn-danger position-absolute"
                            style={{ top: '0', right: '0', padding: '0 5px' }}
                            onClick={() => {
                              // Remove image at this index
                              const newUrls = [...urlImages];
                              const newFiles = [...fileImages];
                              newUrls.splice(index, 1);
                              newFiles.splice(index, 1);
                              setUrlImages(newUrls);
                              setFileImages(newFiles);
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                  <input
                    key={fileInputKey}
                    type="file"
                    id="myfile"
                    name="myfile"
                    lang="vi"
                    style={{ height: "45px" }}
                    multiple
                    className="form-control mt-2"
                    onChange={(e) => {
                      uploadImages(e);
                    }}
                  />
                  <small className="text-muted mt-1">Bạn có thể chọn nhiều ảnh cùng lúc</small>
                </div>
                <div className="row">
                  <button
                    type="button"
                    className="save-btn btn-lg btn-block code-box"
                    onClick={() => sendData(fieldParams)}
                    disabled={isSending || justSubmitted}
                    style={{ backgroundColor: (isSending || justSubmitted) ? "#ccc" : null }}
                  >
                    {isSending ? "Đang gửi" : justSubmitted ? "Đã đóng góp" : "Đóng góp"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ContributeTechnicalProcess;
